import CommonIntroductionBase from "./common/CommonIntroductionBase";

const SmallScallAppDevelopment = () => {
  return (
    <CommonIntroductionBase
      slide="小規模アプリ開発"
      collectionName="smallscallappdevelopment"
      postTitle="社会問題解決情報"
      targetItems={[
        "order",
        "title",
        "content",
        "linkUrl",
        "youtubeUrl",
        "image",
      ]}
      enableMarkdown
    />
  );
};

export default SmallScallAppDevelopment;
